import { propertyValidationConfig } from "./validationConfig";

export const validateListing = ({
  listingType,
  ApartmentData,
  VillaData,
  PlotsData,
}) => {
  const errors = {};

  const moduleDataMap = {
    Apartments: ApartmentData,
    Villas: VillaData,
    Plots: PlotsData,
  };

  const requiredFields = propertyValidationConfig[listingType] || [];
  const data = moduleDataMap[listingType] || {};

  requiredFields.forEach((fieldObj) => {
    const key = typeof fieldObj === "string" ? fieldObj : fieldObj.key;
    const label =
      typeof fieldObj === "string"
        ? fieldObj
        : fieldObj.label || fieldObj.key;

    const value = data[key];

    if (
      value === undefined ||
      value === null ||
      value.toString().trim() === ""
    ) {
      errors[key] = `${label} is required`;
    }
  });

  return errors;
};